export enum SideBlockMode {
  EDIT = "edit",
  CREATE = "create",
  VIEW = "view",
  CLOSED = "closed",
  READ_ONLY = "read_only",
}
